import { App, defineAsyncComponent } from 'vue'

const View = defineAsyncComponent(() => import('./View.vue'))

const install = (app: App<Element>, prefix = 'CatalogMap'): void => {
  app
    .component(`${prefix}View`, View)
}

export default {
  install,
}
